<template>
    <splide v-if="items.length > 1"
            :options="options"
            role="region"
            aria-label="Carousel of latest news and videos">
        <splide-slide v-for="(item, index) in items"
                      :key="index"
                      role="group"
                      aria-roledescription="Carousel item"
                      class="item">
            <a :href="item.video_id ? route('videos') + '?video-id=' + item.video_id : item.url"
               :target="item.is_external && '_blank'"
               :rel="item.is_external && 'nofollow noindex noopener'"
               class="w-100">
                <div :class="{youtube: item.video_id}"
                     class="position-relative">
                    <div class="image-placeholder placeholder-loading d-none" />
                    <img loading="lazy"
                         width="100%"
                         height="100%"
                         :src="asset_cdn(item.image_url, 265, 150)"
                         :alt="item.title"
                         class="cursor-pointer">
                    <img v-if="item.video_id"
                         class="play-button list"
                         loading="lazy"
                         :src="asset_cdn('crypto/assets/video-button.png', 60)"
                         :alt="item.title">
                </div>
                <p class="category mb-0 text-capitalize">
                    <translate v-if="item.video_id"
                               translation-key="videos.video"
                               fallback="video" />
                    <span v-else>
                        <translate :translation-key="'news.' + item.category"
                                   :fallback="item.category" />
                    </span>
                </p>
                <p class="title mb-0">{{ item.title }}</p>
            </a>
        </splide-slide>
        <splide-slide class="item">
            <a :href="route('news')"
               class="w-100 d-flex flex-column justify-content-center align-items-center text-center"
               target="_blank">
                <div>
                    <div class="main mb-1">
                        <translate translation-key="cryptocurrency-prices.wantMoreTitle" />
                    </div>
                    <div class="secondary mb-3">
                        <translate translation-key="cryptocurrency-prices.wantMoreNewsSubtitle" />
                    </div>
                </div>
                <div class="right-arrow d-flex justify-content-center align-items-center">
                    <i class="fa-solid fa-chevron-right" />
                </div>
            </a>
        </splide-slide>
    </splide>
</template>

<script>
    import { Splide, SplideSlide } from '@splidejs/vue-splide';
    import { asset_cdn, route } from '@/js/helpers/helpers';

    export default {
        components: {
            Splide,
            SplideSlide,
        },
        props: {
            items: {
                type: Array,
                default: () => [],
                required: true,
            },
            cardCount: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                options: {
                    type: 'slide',
                    autoplay: false,
                    pagination: false,
                    gap: '16px',
                    perPage: this.cardCount,
                    perMove: this.cardCount,
                    arrowPath: 'M15.783 9.116C16.271 8.628 17.062 8.628 17.551 9.116L27.551 '
                        + '19.116C28.039 19.604 28.039 20.396 27.551 20.884L17.551 30.884C17.062'
                        + ' 31.372 16.271 31.372 15.783 30.884C15.295 30.396 15.295 29.604 15.783 '
                        + '29.116L24.899 20L15.783 10.884C15.295 10.396 15.295 9.604 15.783 9.116Z',
                    breakpoints: {
                        800: {
                            perPage: 2,
                            perMove: 2,
                        },
                        1070: {
                            perPage: this.cardCount - 2,
                            perMove: this.cardCount - 2,
                        },
                        1350: {
                            perPage: this.cardCount - 1,
                            perMove: this.cardCount - 1,
                        },
                    },
                    lazyLoad: true,
                    speed: 800,
                    padding: { right: 6, left: 6 },
                },
                toggler: false,
                slide: 1,
            };
        },
        methods: { route, asset_cdn },
    };
</script>
